import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { reservation } from "@/mixins/index";
export default {
  mixins: [reservation],
  data: function data() {
    return {
      pagingList: [],
      dialogShow: false
    };
  },
  mounted: function mounted() {},
  activated: function activated() {},
  methods: {
    open: function open(id) {
      var _this = this;

      this.$api.adminUserLottery({
        user_id: id
      }).then(function (res) {
        if (res.code == 0) {
          res.data.map(function (i) {
            i.itemname = _this.itemList.find(function (j) {
              return j.value == i.item_id;
            }).label;
          });
          _this.pagingList = res.data;
          _this.dialogShow = true;
        }
      });
    }
  }
};